import React, { Fragment } from 'react'

export function CompanyDetailsEn() {
  return (
    <Fragment>
      <div className="company-details-field">
        <span className="company-details-field__label">Legal Name</span>
        <span className="company-details-field__text">Darpo Vision FZ LLC</span>
      </div>
      <div className="company-details-field">
        <span className="company-details-field__label">Trade Name</span>
        <span className="company-details-field__text">VIORY</span>
      </div>
      <div className="company-details-field">
        <span className="company-details-field__label">Address</span>
        <span className="company-details-field__text">
          Yas Creative Hub Tower 2, Yas South 769931, Abu Dhabi, United Arab
          Emirates
        </span>
      </div>
      <div className="company-details-field">
        <span className="company-details-field__label">PO Box</span>
        <span className="company-details-field__text">
          769931, Abu Dhabi, UAE
        </span>
      </div>
      <div className="company-details-field">
        <span className="company-details-field__label">Trade License</span>
        <span className="company-details-field__text">B.L. 1252/23</span>
      </div>

      <div className="company-details-field">
        <span className="company-details-field__label">Client Service</span>
        <span className="company-details-field__text">
          <span className="company-details__mail">
            <a href="mailto:cs@viory.video">cs@viory.video</a>
          </span>
        </span>
      </div>

      <div className="company-details-field">
        <span className="company-details-field__label">Submit Your Story</span>
        <span className="company-details-field__text">
          <span className="company-details__mail">
            <a href="mailto:sendvideo@viory.video">sendvideo@viory.video</a>
          </span>
        </span>
      </div>

      <div className="company-details-field">
        <span className="company-details-field__label">Press Contact</span>
        <span className="company-details-field__text">
          <span className="company-details__mail">
            <a href="mailto:pr@viory.video">pr@viory.video</a>
          </span>
        </span>
      </div>
      <div className="company-details-field company-details-field--padded">
        <span className="company-details-field__label">Disclaimer</span>
        <span className="company-details-field__text company-details-field__text--padded">
          Our Website may from time to time contain links to other websites and
          resources ("External Links"). We are not responsible for, and have no
          liability as a result of the availability of External Links or their
          contents. We suggest that You review the terms of use and privacy
          statements of such External Links prior to using them.
        </span>
      </div>
    </Fragment>
  )
}

export const CompanyDetailsMapEn = () => (
  <div className="company-details-block__map-container">
    <iframe
      className="company-details-block__map"
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1815.8418544206074!2d54.5998516!3d24.4617566!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e45eef5646855%3A0x8c31ff8520a7f72b!2sYas%20Creative%20Hub!5e0!3m2!1sen!2sde!4v1692864579525!5m2!1sen!2sde"
      width="600"
      height="450"
      style={{ border: 0 }}
      allowfullscreen
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
)

